export const LanguageLevelValues = ['Undefined', 'Basic', 'Medium', 'Fluent', 'NativeBilingual'];
//# sourceMappingURL=language-level.js.map